module.exports = __webpack_public_path__ + "img/feedback_safe.9c249844.svg";